import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import EmpoweringAfricanExcellence from "./sections/EmpoweringAfricanExcellence";
import OurEducationalLegacy from "./sections/OurEducationalLegacy";
import PurposeAndFuture from "./sections/PurposeAndFuture";
import ExecutiveTrainingProgrammes from "./sections/ExecutiveTrainingProgrammes";
import OurServicePackages from "./sections/OurServicePackages";
import BeginYourTransformation from "./sections/BeginYourTransformation";
import InstitutionalFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <EmpoweringAfricanExcellence />
      <OurEducationalLegacy />
      <PurposeAndFuture />
      <ExecutiveTrainingProgrammes />
      <OurServicePackages />
      <BeginYourTransformation />
      <InstitutionalFooter />
    </div>;
}